<div class="wrapper flex justify-center items-center w-full min-h-screen p-4 bg-gray-50">
    <mat-card appearance="outlined" class="w-full max-w-sm mx-auto bg-white shadow-lg rounded-xl overflow-hidden">

        <mat-card-header class="flex flex-col items-center pt-6 pb-0">
            <div class="flex justify-center mb-4">
                <img class="w-24 h-24 object-contain" [src]="branding.imageUrl" alt="logo"/>
            </div>

            @if (!currentTicket) {
                <mat-card-title class="text-center w-full">
                    <div class="text-xl font-bold text-gray-800">
                        Enregistrer une personne dans la file d'attente
                    </div>
                </mat-card-title>
            }
            @else {
                <mat-card-title class="text-center w-full">
                    <div class="text-xl font-bold text-gray-800">
                        Numéro attribué
                    </div>
                </mat-card-title>
            }
        </mat-card-header>

        <mat-card-content class="p-6">
            @if (!currentTicket) {
                <form [formGroup]="queueForm" class="flex flex-col gap-3" autocomplete="off">

                    <mat-form-field class="fuse-mat-dense w-full" subscriptSizing="dynamic">
                        <mat-label>Prénom</mat-label>
                        <input matInput [formControlName]="'firstName'" autocomplete="off">
                    </mat-form-field>

                    <mat-form-field class="fuse-mat-dense w-full" subscriptSizing="dynamic">
                        <mat-label>Nom</mat-label>
                        <input matInput [formControlName]="'lastName'" autocomplete="off">
                    </mat-form-field>

                    <entry-selector [title]="'Motif*'" [options]="motifs" [formControlName]="'motif'" class="fuse-mat-dense w-full"></entry-selector>

                    <div class="mt-4 w-full">
                        @if (successMessage) {
                            <fuse-alert [type]="'success'" class="mb-2">
                                <span fuseAlertTitle>Succès</span>
                                {{ successMessage }}
                            </fuse-alert>
                        }
                        @if (errorMessage) {
                            <fuse-alert [type]="'error'" class="mb-2">
                                <span fuseAlertTitle>Erreur</span>
                                {{ errorMessage }}
                            </fuse-alert>
                        }

                        <button type="button" mat-flat-button color="primary" class="w-full rounded-full py-2 text-base" (click)="joinQueue()" [disabled]="isSubmitting">
                            <span>{{ isSubmitting ? 'Enregistrement...' : "S'enregistrer dans la file d'attente" }}</span>
                        </button>
                    </div>
                </form>
            }
            @else {
                <div class="flex flex-col items-center justify-center py-6 animate-fade-in">

                    <span class="text-gray-500 font-medium uppercase tracking-widest text-xs mb-4">
                        Numéro de passage
                    </span>

                    <div class="w-48 h-48 rounded-full bg-blue-50 border-4 border-blue-100 flex items-center justify-center mb-6 shadow-sm">
                        <span class="text-7xl font-black text-blue-600 tracking-tighter">
                            {{ currentTicket.number }}
                        </span>
                    </div>

                    <div class="mb-6">
                        <div class="inline-flex items-center px-4 py-2 rounded-full bg-yellow-50 text-yellow-700 font-semibold text-sm border border-yellow-100">
                            <mat-icon class="icon-size-5 mr-2" [svgIcon]="'heroicons_solid:clock'"></mat-icon>
                            En attente
                        </div>
                    </div>

                    <p class="text-center text-gray-400 text-sm px-8 leading-relaxed mb-6">
                        Notez ce numéro puis utilisez le bouton ci-dessous pour enregistrer la personne suivante.
                    </p>

                    <button type="button" mat-stroked-button color="primary" class="w-full rounded-full py-2 text-base" (click)="registerAnotherPerson()">
                        Enregistrer une autre personne
                    </button>
                </div>
            }
        </mat-card-content>
    </mat-card>
</div>
